module.exports = __webpack_public_path__ + "img/platform-analytics.45026445.png";